// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React, { FunctionComponent, Fragment } from 'react';
import { Auth } from 'app/scripts/db/auth';
import { CheckIcon } from '@trello/nachos/icons/check';
import cx from 'classnames';

import { forTemplate } from '@trello/i18n';
const format = forTemplate('board_menu_settings');

interface BoardMenuSettingsProps {
  orgDisplayName: string;
  isMapMarkerColorFFEnabled: boolean;
  isTemplate: boolean;
  commentsDisplay: string;
  votingEnabled: boolean;
  votingDisplay: string;
  invitationsDisplay: string;
  canChangeOrg: boolean;
  owned: boolean;
  cardCovers: boolean;
  isMapMarkerColorSettingEnabled: boolean;
  permissionLevel: string;
  selfJoin: boolean;
  hasOrg: boolean;
  idOrganization: string;
}

export const BoardMenuSettings: FunctionComponent<BoardMenuSettingsProps> = ({
  orgDisplayName,
  isMapMarkerColorFFEnabled,
  isTemplate,
  commentsDisplay,
  votingEnabled,
  votingDisplay,
  invitationsDisplay,
  canChangeOrg,
  owned,
  cardCovers,
  isMapMarkerColorSettingEnabled,
  permissionLevel,
  selfJoin,
  hasOrg,
  idOrganization,
}) => {
  const isPrivate = permissionLevel === 'private';
  const isLoggedIn = Auth.isLoggedIn();

  return (
    <Fragment>
      {!isLoggedIn && (
        <>
          <ul className="board-menu-navigation">
            <li className="board-menu-navigation-item">
              <a
                href="#"
                className="js-change-cookie-settings board-menu-navigation-item-link"
              >
                <span className="icon-sm icon-gear board-menu-navigation-item-link-icon" />
                &nbsp;{format('cookie-settings')}
              </a>
            </li>
          </ul>
          <hr />
        </>
      )}
      <div>
        <ul className="pop-over-list inset">
          <li>
            <a
              href="#"
              className={cx('js-change-org', { disabled: !canChangeOrg })}
            >
              {canChangeOrg && format('change-organization-ellipsis')}
              <span className="sub-name">
                {orgDisplayName && `${orgDisplayName}`}
              </span>
            </a>
          </li>
          <hr />
          <li>
            <a href="#" className={owned ? 'js-toggle-covers' : 'disabled'}>
              {!cardCovers && format('enable-card-covers')}
              {cardCovers && (
                <Fragment>
                  {format('card-covers-enabled')}
                  <CheckIcon />
                </Fragment>
              )}
              <span className="sub-name">
                {format(
                  'show-image-attachments-and-colors-on-the-front-of-cards',
                )}
              </span>
            </a>
          </li>
          <hr />
          {isMapMarkerColorFFEnabled && (
            <>
              <li>
                <a
                  href="#"
                  className={owned ? 'js-toggle-map-marker' : 'disabled'}
                >
                  {!isMapMarkerColorSettingEnabled &&
                    format('enable-map-marker-color')}
                  {isMapMarkerColorSettingEnabled && (
                    <Fragment>
                      {format('map-marker-color-enabled')}
                      <CheckIcon />
                    </Fragment>
                  )}
                  <span className="sub-name">
                    {format('show-map-marker-color')}
                  </span>
                </a>
              </li>
              <hr />
            </>
          )}
          {!isTemplate && (
            <li>
              <a href="#" className={owned ? 'js-change-comments' : 'disabled'}>
                {format('commenting-permissions-ellipsis')}
                <span className="sub-name">{commentsDisplay}</span>
              </a>
            </li>
          )}
          {votingEnabled && (
            <li>
              <a href="#" className={owned ? 'js-change-voting' : 'disabled'}>
                {format('voting-permissions-ellipsis')}
                <span className="sub-name">{votingDisplay}</span>
              </a>
            </li>
          )}
          {!isTemplate && (
            <>
              <li>
                <a
                  href="#"
                  className={owned ? 'js-change-add-members' : 'disabled'}
                >
                  {format('invitations-permissions-ellipsis')}
                  <span className="sub-name">{invitationsDisplay}</span>
                </a>
              </li>
              <hr />
            </>
          )}
          {!isTemplate && (
            <li>
              <a
                href="#"
                className={cx({
                  'js-toggle-org-mem-join': owned,
                  disabled: !idOrganization || !owned || isPrivate,
                })}
              >
                <span>
                  {format('allow-team-members-to-edit-and-join')}
                  {selfJoin && <CheckIcon />}
                </span>
                <span className="sub-name">
                  {hasOrg &&
                    isPrivate &&
                    format(
                      'any-team-member-can-edit-and-join-this-board-to-enable-this-the-board-cant-be-private',
                    )}
                  {hasOrg &&
                    !isPrivate &&
                    format('any-team-member-can-edit-and-join-this-board')}
                  {!hasOrg &&
                    isPrivate &&
                    format(
                      'any-team-member-can-edit-and-join-this-board-to-enable-this-the-board-has-to-be-a-part-of-a-team-and-the-board-cant-be-private',
                    )}
                  {!hasOrg &&
                    !isPrivate &&
                    format(
                      'any-team-member-can-edit-and-join-this-board-to-enable-this-the-board-has-to-be-a-part-of-a-team',
                    )}
                </span>
              </a>
            </li>
          )}
        </ul>
      </div>
    </Fragment>
  );
};
